/*
 * Copyright (C) 2020-present Borza LLC. All rights reserved.
 */

import Head from "next/head";
import { Component } from "react";

class Error extends Component {
  public render() {
    const title = "Error";
    const description = "";

    return (
      <>
        <Head>
          <title>{title}</title>
          <meta
            content={description}
            name="description"
          />
        </Head>
        <div>
          <p>Oops, you have encountered an error.</p>
        </div>
      </>
    );
  }
}

export default Error;
